<template>
  <div class="model-3D relative">
    <!-- <div class="controls">
      <button @click="getCameraPostion">Get Camera Position</button>
    </div> -->
    <!-- 静态图片展示 -->
    <div v-if="isPaperMaking" id="yiImg" class="relative " :style="`position: absolute;width:720px;height:600px;${faultPoint.img_position}left:62%;transform:translate(-50%, -50%);z-index:1944;`">
      <!-- <img  src="../../../assets/images/dashboard/zaozhi_model.png" alt=""  style="width: 100%;height: 100%;"> -->
      <img  :src="faultPoint.img" alt=""  :style="faultPoint.img_style">
        <!-- demo测点1 -->
        <div class="showButton" id="point-zkb" :style="faultPoint.style1">
          <div
            id="state-zkb"
            :class="'success'"
            style="position: absolute; top: 120%"
            :style="$i18n.locale !== 'ch' && { fontSize: '14px' }"
          >
            <img :src="faultImg[status_hrq]" alt="" class="icon-fault" />
            <span>{{ $t("结垢") }}</span>
          </div>
          <div
            :class="['innerCircle', 'success']"
            @click="handlerShowPeanlFun('轴承温度',1)"
            style="z-index: 999; cursor: pointer"
          ></div>
          <div
            :class="['outerCircle', 'success']"
            @click="handlerShowPeanlFun('轴承温度',1)"
            style="z-index: 999; cursor: pointer"
          ></div>
          <!--  @click="handlerShowPeanl1('轴承温度')" -->
          <div
            v-if="showPeanl1"
            class="position-absolute"
            :style="
              `${faultPoint.point1.style1}
              box-sizing: border-box;
              aspect-ratio: 1116 / 1114;`
            "
          >
                    <!--               top: -302px;
              aspect-ratio: 1514 / 907;
              right: -655px; -->
            <img :src="faultPoint.point1.img" alt="#" :style="faultPoint.point1.img_style" />
            <div
              :style="
                `position: absolute;
                ${faultPoint.point1.style2}
                border-top-left-radius: 25px;
                background-color: rgba(92, 242, 110, 0.3);
                border-bottom-right-radius: 40px;`
              "
            >
            <!--                 width: 355px;
                height: 404px;
                position: absolute;
                top: 3px;
                left: 326px; -->
              <div :class="['mark-head']" style="background-color: #5df36f">
                <div class="head">
                  <span class="icon-h">
                    <img :src="faultImg[status_hrq]" alt="" />
                  </span>
                  <span
                    class="head-cont"
                    :style="$i18n.locale !== 'ch' && { fontSize: '20px' }"
                    >{{ $t("结垢") }}</span
                  >
                </div>
                <div class="online-shop" @click="handlerJump2Shop()">
                  <span>{{ $t("Online Service") }}</span>
                  <img
                    src="@/assets/icon-onlineShop.svg"
                    alt=""
                    class="icon-online"
                  />
                </div>
              </div>
              <div :class="['mark-body']">
                <div
                  v-for="(list, index) in cont_zzc_demo1"
                  :key="index"
                  class="mark-main"
                  :style="$i18n.locale !== 'ch' && { paddingTop: '5px' }"
                >
                  <div class="main-head">
                    <img class="title-icon" src="@/assets/setting.svg" />
                    <span class="mark-title">{{ list.title }}</span>
                  </div>
                  <div
                    v-for="(cont, i) in list.cont"
                    :key="i"
                    class="mark-cont"
                    :style="
                      $i18n.locale !== 'ch' && {
                        fontSize: '14px',
                        lineHeight: '16px',
                      }
                    "
                  >
                    <img src="@/assets/point.svg" class="point-icon" alt="" />
                    <span>{{ cont }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- demo测点2 -->
        <div class="showButton" id="point-hrq" :style="faultPoint.style2">
          <div
            id="state-hrq"
            :class="'success'"
            style="position: absolute; top: -100%"
            :style="$i18n.locale !== 'ch' && { fontSize: '14px' }"
          >
            <img :src="faultImg[status_zkb]" alt="" class="icon-fault" />
            <span>{{ $t("smart_OM_model_paper_making.surge_warning") }}</span>
          </div>
          <div
            :class="['innerCircle', 'success']"
            @click="handlerShowPeanlFun('振动噪音', 3)"
            style="z-index: 999; cursor: pointer"
          ></div>
          <div
            :class="['outerCircle', 'success']"
            @click="handlerShowPeanlFun('振动噪音', 3)"
            style="z-index: 999; cursor: pointer"
          ></div>
          <!-- @click="handlerShowPeanl3('振动噪音', loading_hrq)" -->
          <div
            v-if="showPeanl3"
            class="position-absolute"
            :style="
                `${faultPoint.point2.style1}
              box-sizing: border-box;
              aspect-ratio: 1514 / 907;`
            "
          >
            <img :src="faultPoint.point2.img" alt="#" :style="faultPoint.point2.img_style" />
            <div
              :style="
                `position: absolute;
                ${faultPoint.point2.style2}
                background-color: rgba(92, 242, 110, 0.3);
                border-top-left-radius: 25px;
                border-bottom-right-radius: 40px;`
              "
            >
              <div :class="['mark-head']" style="background-color: #5df36f">
                <div class="head">
                  <span class="icon-h">
                    <img :src="faultImg[status_zkb]" alt="" />
                  </span>
                  <span
                    class="head-cont"
                    :style="$i18n.locale !== 'ch' && { fontSize: '20px' }"
                    >{{ $t("smart_OM_model_paper_making.surge_warning") }}</span
                  >
                </div>
                <div class="online-shop" @click="handlerJump2Shop()">
                  <span>{{ $t("Online Service") }}</span>
                  <img
                    src="@/assets/icon-onlineShop.svg"
                    alt=""
                    class="icon-online"
                  />
                </div>
              </div>
              <div :class="['mark-body']">
                <div
                  v-for="(list, index) in cont_zzc_demo2"
                  :key="index"
                  class="mark-main"
                  :style="$i18n.locale !== 'ch' && { paddingTop: '5px' }"
                >
                  <div class="main-head">
                    <img class="title-icon" src="@/assets/setting.svg" />
                    <span class="mark-title">{{ list.title }}</span>
                  </div>
                  <div
                    v-for="(cont, i) in list.cont"
                    :key="i"
                    class="mark-cont"
                    :style="
                      $i18n.locale !== 'ch' && {
                        fontSize: '14px',
                        lineHeight: '16px',
                      }
                    "
                  >
                    <img src="@/assets/point.svg" class="point-icon" alt="" />
                    <span>{{ cont }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
    </div>
    <div class="scene relative" id="webgl" style="outline: none"></div>
    <div id="penal"></div>
    <!-- loading -->
    <div v-if="showLoading" class="loading">
      <div class="loading-animat" v-if="loadingState">
        <div class="dot dot1"></div>
        <div class="dot dot2"></div>
        <div class="dot dot3"></div>
        <div class="dot dot4"></div>
        <div class="dot dot5"></div>
        <div class="dot dot6"></div>
        <div class="dot dot7"></div>
        <div class="dot dot8"></div>
      </div>
      <div class="loading-static" v-else>
        <div class="dot-static dot1"></div>
        <div class="dot-static dot2"></div>
        <div class="dot-static dot3"></div>
        <div class="dot-static dot4"></div>
        <div class="dot-static dot5"></div>
        <div class="dot-static dot6"></div>
        <div class="dot-static dot7"></div>
        <div class="dot-static dot8"></div>
      </div>
      <div class="text">
        {{ loadingState ? loadText["loading"] : loadText["finished"] }}
      </div>
    </div>
    <Loading
      style="position: absolute; top: 35%; right: 15%"
      :loadingState="loadingState"
    ></Loading>
  </div>
</template>

<script>
import * as THREE from "three";
import GLTFLoader from "three-gltf-loader";
const OrbitControls = require("three-orbitcontrols");
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import {
  CSS2DRenderer,
  CSS2DObject,
} from "three/examples/jsm/renderers/CSS2DRenderer.js";
import { IS_DEMO_PAPER_MAKING_EP1000_ID } from "@/config/common";
import Loading from "@/components/common/Loading";
import i18n from "@/i18n";
import _ from "lodash";

let renderer,
  controls,
  scene,
  camera,
  css2DRenderer,
  ambientLight,
  pointLight1,
  pointLight2;

export default {
  name: "VSD420-F-Model",
  data() {
    return {
      showLoading: false,
      loadingState: true,
      canClick: true,
      showPoint: true,
      lineObject: [],
      penalObject: [],
      showPeanl: false,
      showPeanl1: false,
      showPeanl2: false,
      showPeanl3: false,
      showPeanl4: false,
      showPeanl5: false,
      showPeanlf1: false,
      showPeanlf2: false,
      faultImg: {
        warning: require("@/assets/warning.svg"),
        error: require("@/assets/error.svg"),
      },
      faultStatus: "warning",
      /* 真空泵电机 */
      status_zkbdj: "error",
      /* 真空泵 */
      status_zkb: "error",
      /* 换热器 */
      status_hrq: "warning",
      timer1: null,
      timer2: null,
      timer4: null,
      timer5: null,
      timer: null,
      is3D:true, // 是否展示3D图
      //demo 造纸厂故障点
      demoFaultPoint: {
        0:{ //EP600
          img: require("@/assets/images/dashboard/zaozhi_model.png"),
          img_position:"top: 50%;",
          img_style:"width: 100%;height: 100%;",
          style1:"position: absolute; transform: translate(-50%, -50%) translate(212px, -230px); z-index: 1954;",
          style2:"position: absolute; transform: translate(-50%, -50%) translate(315px, -230px); z-index: 1954;",
          point1:{ //结垢
            img: require("@/components/devices/VSD420-Fault/right.png"),
            style1:"height: 470px;top: -466px;right: 69px;",
            img_style:"width: 110%;height: 105%;",
            style2:"width: 392px;height: 397px;top: 3px;left: 2px;",
          },
          point2:{ //喘振
            img: require("@/components/devices/VSD420-Fault/left.png"),
            style1:"height: 410px;top: -302px;right: -655px;",
            img_style:"",
            style2:"width: 355px;height: 404px;top: 3px;left: 326px;",
          },
        },
        1:{ //EP1000
          img: require("@/assets/images/dashboard/EP1000_model.png"),
          img_position:"top: 60%;",
          img_style:"width: 100%;height: 74%;",
          style1:"position: absolute; transform: translate(-50%, -50%) translate(248px, -205px); z-index: 1954;",
          style2:"position: absolute; transform: translate(-50%, -50%) translate(148px, -205px); z-index: 1954;",
          point1:{ //喘振
            img: require("@/components/devices/VSD420-Fault/left.png"),
            style1:"height: 470px;top: -295px;left: 25px;",
            img_style:"width: 130%;height: 85%;",
            style2:"width: 322px;height: 395px;top: 3px;left: 291px;",
          },
          point2:{ //结垢
            img: require("@/components/devices/VSD420-Fault/right.png"),
            style1:"height: 492px;top: -466px;left: -404px;",
            img_style:"width: 53%;height: 100%;",
            style2:"width: 333px;height: 397px;top: 3px;left: 0px;",
          },
          
        }
      },
      faultPoint: {},
    };
  },
  emits: ["changeBreak", "onlineChange"],
  props: {
    onlineShop: {
      /* 模型 */
      type: Boolean,
      default: false,
    },
    breakdown_point: {
      type: String,
      default: () => {
        return "";
      },
    },
    equip_data: {
      /* 设备实例详情 */
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    equip_data: {
      handler(newValue) {
        if (newValue) {
          // 造纸演示客户机组设备 EP1000 故障点展示
          this.faultPoint = newValue.id == IS_DEMO_PAPER_MAKING_EP1000_ID ? this.demoFaultPoint[1] : this.demoFaultPoint[0];
        }
      },
      immediate: true
    }
  },
  computed: {
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    },
    //造纸厂展示内容--故障1
    cont_zzc_demo1() {
      return [
        {
          title: this.$t("smart_OM_model_paper_making.fault_name"),//故障名称
          cont: [
            this.$t("结垢"), //结垢
          ],
        },
        {
          title: this.$t("Symptoms"),//现场表征
          cont: [
            this.$t("smart_OM_model_paper_making.gradual_increase_in_vibration_levels"),//"振动缓慢增加(振动水平从一开始的0.3-09经过几个月的运行增长到2.0以上)"
          ],
        },
        {
          title: this.$t("Root cause analysis"), //原因分析
          cont: [
          this.$t("smart_OM_model_paper_making.residual_fibers_and_other_particulates_remaining_after"),// "经过过滤剩余的纤维等附着在叶轮上导致振动增加",
          ],
        },
        {
          title: this.$t("Advice"),//操作建议
          cont: [
            this.$t("smart_OM_model_paper_making.we_have_developed_an_intelligen_spray"),//"我方针对此类问题开发智能喷淋系统，可有效较低叶轮清洗时间",
          ],
        }
      ];
    },
    //造纸厂展示内容--故障2
    cont_zzc_demo2() {
      return [
        {
          title: this.$t("smart_OM_model_paper_making.fault_name"),//故障名称
          cont: [
            this.$t("smart_OM_model_paper_making.surge_warning"), //预警
          ],
        },
        {
          title: this.$t("Symptoms"),//现场表征
          cont: [
          this.$t("smart_OM_model_paper_making.sudden_increase_in_vibration_fluctuations"), //"振动突然增加，真空度波动"
          ],
        },
        {
          title: this.$t("Root cause analysis"), //原因分析
          cont: [
            this.$t("smart_OM_model_paper_making.a_sudden_drop_in_system_pumping_speed_due"),//"系统抽速由于工艺等原因突然降低导致透平机进入喘振区",
          ],
        },
        {
          title: this.$t("Advice"),//操作建议
          cont: [
            this.$t("smart_OM_model_paper_making.we_provide_an_intelligent_antisurge_control_logic"),//"提供智能防喘控制逻辑，正常运行时无法进入喘振区，工艺原因导致设备即将进入喘振时即自动开启补气阀",
          ],
        }
      ];
    },
    fault_zkbdj() {
      return {
        warning: this.$t("Motor Overloaded Caution"),
        error: this.$t("Motor Overloaded Warning"),
      };
    },
    cont_zkbdj() {
      return [
        {
          title: this.$t("Symptoms"),
          cont: [this.$t("Motor current enters the high-risk zone")],
        },
        {
          title: this.$t("Root cause analysis"),
          cont: [this.$t("Refer to the motor manual")],
        },
        {
          title: this.$t("Advice"),
          cont: [
            this.$t(
              "Refer to the motor manual, if the power exceeds 10% of the rated power, it is recommended to switch the backup machine"
            ),
          ],
        },
      ];
    },
    fault_zkb() {
      return {
        warning: this.$t("Low risk early warning of bearing"),
        error: this.$t("High risk early warning of bearing"),
      };
    },
    cont_zkb() {
      return [
        {
          title: this.$t("Symptoms"),
          cont: [
            this.$t("High equipment bearing temperature enters high risk zone"),
          ],
        },
        {
          title: this.$t("Root cause analysis"),
          cont: [
            this.$t("Too much or too little grease"),
            this.$t("Degradation of grease"),
            this.$t("Bearing damage"),
            this.$t("Coupling or belt alignment problems"),
            this.$t("Improper bearing installation"),
          ],
        },
        {
          title: this.$t("Advice"),
          cont: [
            this.$t(
              "Troubleshooting according to the above reasons, if the temperature is higher than 100 °C, it is recommended to switch the backup machine"
            ),
          ],
        },
      ];
    },
    fault_zkb_demo() {
      return {
        warning: this.$t("Low risk early warning of bearing"),
        error: this.$t("Pump Stuck Warning"),
      };
    },
    cont_zkb_demo() {
      return [
        {
          title: this.$t("Symptoms"),
          cont: [
            this.$t("泵运行平稳，没有异常噪音或振动"),
            this.$t("液体流量和压力在正常范围内，没有出现剧烈波动"),
            this.$t("泵壳和叶轮表面无明显汽蚀损伤或腐蚀痕迹。"),
          ],
        },
        {
          title: this.$t("Root cause analysis"),
          cont: [this.$t("暂无风险")],
        },
        {
          title: this.$t("Advice"),
          cont: [
            this.$t(
              "请遵照佶缔纳士原厂使用说明书上的维护建议进行定期检修，维修设备健康和稳定高效的运行。"
            ),
          ],
        },
      ];
    },
    cont_zkb_left_demo() {
      return [
        {
          title: this.$t("Symptoms"),
          cont: [
            this.$t("轴承和泵体振动正常"),
            this.$t("无较大噪音"),
            this.$t("泵腔内无较大异响"),
          ],
        },
        {
          title: this.$t("Root cause analysis"),
          cont: [this.$t("设备运行环境良好，无灰尘、杂质等污染物进入轴承区域")],
        },
        {
          title: this.$t("Advice"),
          cont: [
            this.$t(
              "请遵照佶缔纳士原厂使用说明书上的维护建议进行定期检修，维修设备健康和稳定高效的运行。"
            ),
          ],
        },
      ];
    },
    fault_hrq() {
      return {
        warning: this.$t("Low risk early warning of noise"),
        error: this.$t("High risk early warning of noise"),
      };
    },
    cont_hrq() {
      return [
        {
          title: this.$t("Symptoms"),
          cont: [this.$t("Motor high vibration detected")],
        },
        {
          title: this.$t("Root cause analysis"),
          cont: [
            this.$t("Coupling alignment"),
            this.$t("Cavitation"),
            this.$t("Pump fouling"),
            this.$t("Loose ground bolts"),
            this.$t("Foreign objects in pump body"),
            this.$t("Exhaust valve plate dislodged"),
            this.$t("Bearing failure"),
          ],
        },
        {
          title: this.$t("Advice"),
          cont: [
            this.$t(
              "Troubleshooting according to the above root causes.If the motor viration continues to increase it is recommended to switch to the backup unit"
            ),
          ],
        },
      ];
    },
    loadText() {
      return {
        loading: i18n.global.t("Analysing"),
        finished: i18n.global.t("Finished"),
      };
    },
    modelList() {
      let data = [];
      if (
        this.equip_data &&
        this.equip_data.files &&
        this.equip_data.files["3d"].length
      ) {
        data = [this.equip_data.files["3d"][0].url];
      }
      //  return [localStorage.getItem('modelStr')||'']
      return data;
    },
    penalList() {
      if (this.$route.query.index == 3) {
        return {
          error: [
            {
              title: this.$t("Symptoms"),
              cont: ["电机绕阻温度高"],
            },
            {
              title: this.$t("Root cause analysis"),
              cont: [
                "电机风冷风机故障",
                "电机水冷系统故障，水泵或换热器风机故障",
                "电机绝缘电阻变小",
              ],
            },
            {
              title: this.$t("Advice"),
              cont: [
                "检查电机温度；",
                "检查电机绝缘；",
                "检查更换电机温度传感器；",
                "检查冷却系统；",
                "检查进气温度。",
              ],
            },
          ],
          warning: [
            {
              title: this.$t("Symptoms"),
              cont: ["鼓风机喘振"],
            },
            {
              title: this.$t("Root cause analysis"),
              cont: [
                "管道内阀门未开",
                "曝气池内负载增加",
                "以较低转速启动风机",
              ],
            },
            {
              title: this.$t("Advice"),
              cont: [
                "检查管道内阀门是否开启；",
                "确认曝气池内负载增加；",
                "以较高转速启动风机；",
              ],
            },
          ],
        };
      } else {
        return {
          error: [
            {
              title: this.$t("Symptoms"),
              cont: [
                this.$t("Torque  of screw pump is in the high-risk zone"),
                this.$t(
                  "The motor current  of screw pump is in the high-risk zone"
                ),
              ],
            },
            {
              title: this.$t("Root cause analysis"),
              cont: [
                this.$t("Startup warmingup process missing"),
                this.$t(
                  "Shutdown clearning and nitrogen purge replacement process missing"
                ),
                this.$t("Low cooling water temperature cause crystallistation"),
                this.$t("Foreign object entry"),
              ],
            },
            {
              title: this.$t("Advice"),
              cont: [
                this.$t("Lowering running speed"),
                this.$t("Open solvent cleaning"),
                this.$t("Increasing cooling water temperature"),
                this.$t(
                  "Confirm whether it is back to normal, otherwise stop and perform endoscopy"
                ),
              ],
            },
          ],
          warning: [
            {
              title: this.$t("Symptoms"),
              cont: [
                this.$t("Screw pump torque abnormal"),
                this.$t("Screw pump motor current abnormal"),
              ],
            },
            {
              title: this.$t("Root cause analysis"),
              cont: [
                this.$t("Startup warmingup process missing"),
                this.$t(
                  "Shutdown clearning and nitrogen purge replacement process missing"
                ),
                this.$t("Low cooling water temperature cause crystallistation"),
                this.$t("Foreign object entry"),
              ],
            },
            {
              title: this.$t("Advice"),
              cont: [
                this.$t("Check for rattling"),
                this.$t("Lowering running speed"),
                this.$t("Open solvent cleaning"),
                this.$t("Increasing cooling water temperature"),
              ],
            },
          ],
        };
      }
    },
    faultList() {
      if (this.$route.query.index == 3) {
        return {
          warning: "鼓风机喘振低风险预警",
          error: "电机绕阻温度高",
        };
      } else {
        return {
          warning: this.$t("Pump Stuck Caution"),
          error: this.$t("Pump Stuck Warning"),
        };
      }
    },
  },
  components: {
    Loading,
  },
  mounted() {
    this.changeStatus();
    if(this.$store.state.equipManagement.is_demonstration_equipment){ //设备展示指定图片
      this.is3D = false
    }else{
      this.init();
      window.addEventListener("resize", () => {
        this.init();
      });
    }

    /* 导致全屏按钮功能无法使用 */
    // window.addEventListener("resize", () => {
    // window.location.reload()
    // });
  },
  methods: {
    getCameraPostion() {
      alert(JSON.stringify(camera.position));
    },
    createMarker(id, { x, y, z }) {
      let domObject = new CSS2DObject(document.getElementById(id));
      domObject.position.x = x;
      domObject.position.y = y;
      domObject.position.z = z;
      return domObject;
    },
    createLine(
      position1 = { x: 0, y: 0, z: 0 },
      position2 = { x: 0, y: 0, z: 0 }
    ) {
      let geometry = new THREE.Geometry();
      let lineMaterial = new THREE.LineBasicMaterial({
        color: "#01E7FF",
      });
      geometry.vertices.push(
        new THREE.Vector3(position1.x, position1.y, position1.z),
        new THREE.Vector3(position2.x, position2.y, position2.z)
      );
      let line = new THREE.Line(geometry, lineMaterial);
      scene.add(line);
    },
    /* 清空模型 */
    clearModel() {
      if (scene && scene.children.length >= 1) {
        scene.children.map((item) => {
          scene.remove(item);
        });
        scene.children = [];
        let domDiv = document.querySelector("#webgl");
        if (domDiv != null) {
          domDiv.innerHTML = "";
        }
        camera = null;
        controls = null;
        scene = null;
        renderer.dispose();
        renderer = null;
      }
    },
    init() {
      document.querySelector("#webgl").innerHTML = "";
      this.clearModel();
      this.$nextTick(() => {
        /* 场景 */
        scene = new THREE.Scene();
        scene.scale.set(0.6, 0.6, 0.6);

        /* 相机设置 */
        camera = new THREE.PerspectiveCamera(
          75,
          window.innerWidth / window.innerHeight,
          1,
          2000
        );
        // camera.position.set(122, 38, 9);
        camera.position.set(145, 64, 20);
        
        camera.lookAt(new THREE.Vector3(0, 0, 0));

        /* 模型加载 */
        var loader = new GLTFLoader();
        var dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath("three/examples/jsm/libs/draco/gltf");
        dracoLoader.setDecoderConfig({ type: "js" });
        dracoLoader.preload();
        loader.setDRACOLoader(dracoLoader);
        this.modelList.map((item) => {
          loader.load(
            item,
            (gltf) => {
              console.log(gltf.scene);
              let model = gltf.scene;
              // model.position.y-=20
              if(this.$route.query.equip_id =="871d21c0-5551-11ef-a113-4bd278884fe5"){
                model.position.y-=30
                model.position.z -= 80;

              }else{
                model.position.z -= 30;
              }
              gltf.scene.traverse((object) => {
                
                if (object.isMesh) {
                  object.material.emissiveMap = object.material.map;
                }
                // /* 测点位置 */
                if (object.name === "706-真空泵电机") {
                  let point_zkbdj = this.createMarker(
                    "point-zkbdj",
                    object.position
                  );
                  point_zkbdj.position.z += 50;
                  scene.add(point_zkbdj);
                }
                if (object.name === "706-真空泵") {
                  let point_zkb = this.createMarker(
                    "point-zkb",
                    object.position
                  );
                  point_zkb.position.z -= 60;
                  point_zkb.position.x += 40;
                  // point_zkb.position.y-=20

                  scene.add(point_zkb);
                }
                if (object.name === "NASH__logo2") {
                  let point_hrq = this.createMarker(
                    "point-hrq",
                    object.position
                  );
                  if(this.$route.query.equip_id =="871d21c0-5551-11ef-a113-4bd278884fe5"){
                    point_hrq.position.z -= 80;
                    point_hrq.position.x += 20;
                  }else{  
                    point_hrq.position.z -= 40;
                    point_hrq.position.x += 60;
                  }
                  // point_hrq.position.y-=20  
                  scene.add(point_hrq);
                }
                if (object.name === "GPB200") {
                  console.log(object);
                }

                let point_f1 = this.createMarker("point-fj1", object.position);
                point_f1.position.x -= 10;
                point_f1.position.y += 100;
                scene.add(point_f1);
                let point_f2 = this.createMarker("point-fj2", object.position);
                point_f2.position.x -= 80;
                point_f2.position.y += 120;

                scene.add(point_f2);
                let point_lgb = this.createMarker("point-lgb", object.position);
                point_lgb.position.x -= 100;
                scene.add(point_lgb);
              });
              mixer = new THREE.AnimationMixer(gltf.scene);

              if (gltf.animations.length) {
                let animationAction = mixer
                  .clipAction(gltf.animations[0])
                  .play();
                animationActions.push(animationAction);
              }
              // this.showPeanl1=true
              // this.showPeanl3=true

              scene.add(model);
            },
            (evt) => {
              console.log(evt);
            },
            function (error) {
              console.error(error);
            }
          );
        });

        /* css渲染器 */
        css2DRenderer = new CSS2DRenderer();
        css2DRenderer.setSize(
          document.querySelector("#webgl").offsetWidth,
          document.querySelector("#webgl").offsetHeight
        );
        css2DRenderer.domElement.style.position = "absolute";
        css2DRenderer.domElement.style.top = "0";
        document.getElementById("penal").appendChild(css2DRenderer.domElement);
        /* 渲染器 */
        renderer = new THREE.WebGLRenderer({
          antialias: true, //减少抗锯齿 优化速度
          alpha: true,
          precision: "mediump",
        }); //着色器开启高精度 highp mediump lowp});
        this.$nextTick(() => {
          renderer.setSize(
            document.querySelector("#webgl").offsetWidth,
            document.querySelector("#webgl").offsetHeight
          );
        });
        renderer.setClearColor(0xffffff, 0);
        renderer.setPixelRatio(window.devicePixelRatio);
        document.getElementById("webgl").appendChild(renderer.domElement);

        let clock = new THREE.Clock();

        let mesh;
        let mixer = new THREE.AnimationMixer(mesh);
        let animationActions = [];

        //控制器
        controls = new OrbitControls(
          camera,
          document.getElementById("webgl"),
          renderer.domElement
        );
        /* 缩放 */
        if (this.$route.query.index == 3) {
          scene.rotation.y = 1;
        }
        controls.enableZoom = false;
        controls.enablePan = false;
        /* 旋转 */
        controls.enableRotate = false;
        // controls.autoRotate = true;
        // controls.autoRotateSpeed = 0.5;
        /* 阻尼系数 */
        // controls.enableDamping = true;
        // controls.dampingFactor = 0.1;
        //限制垂直方向的旋转
        // controls.minPolarAngle = Math.PI * 0.38;
        // controls.maxPolarAngle = Math.PI * 0.38;

        //light
        this.setLight();

        const animate = () => {
          controls.update();
          var delta = clock.getDelta();
          if (mixer != null) {
            mixer.update(delta);
          }

          renderer.render(scene, camera);

          css2DRenderer.render(scene, camera);

          requestAnimationFrame(animate);
        };

        animate();
      });
    },
    /* 全景灯光 */
    setLight() {
      ambientLight = new THREE.AmbientLight(0xffffff, 1);
      ambientLight.position.set(0, 100, 0);

      pointLight1 = new THREE.PointLight(0xffffff, 0.8);
      pointLight1.position.set(-2616, 1719, 1502);

      pointLight2 = new THREE.PointLight(0xffffff, 0.8);
      pointLight2.position.set(202, 202, -232);

      scene.add(ambientLight, pointLight1, pointLight2);
    },
    handlerShowPeanlf1(point) {
      this.$emit("changeBreak", point);
      /* 隐藏数据版状态下 */
      if (this.showPeanlf1) {
        this.showPeanlf1 = !this.showPeanlf1;
      } else {
        clearTimeout(this.timer1);
        this.showLoading = true;
        this.showPeanlf2 = false;

        // console.log(this.showPeanlf1, this.showLoading);
        this.timer1 = setTimeout(() => {
          this.showLoading = false;
          this.loadingState = true;
          this.showPeanlf1 = true;
          this.canClick = true;
        }, 5000);
      }
    },
    handlerShowPeanlf2(point) {
      this.$emit("changeBreak", point);
      /* 隐藏数据版状态下 */
      if (this.showPeanlf2) {
        this.showPeanlf2 = !this.showPeanlf2;
      } else {
        clearTimeout(this.timer1);
        this.showLoading = true;
        this.showPeanlf1 = false;
        // console.log(this.showPeanlf2, this.showLoading);
        this.timer1 = setTimeout(() => {
          this.showLoading = false;
          this.loadingState = true;
          this.showPeanlf2 = true;
          this.canClick = true;
        }, 5000);
      }
    },
    handlerShowPeanl(point) {
      this.$emit("changeBreak", point);
      /* 隐藏数据版状态下 */
      if (this.showPeanl) {
        this.showPeanl = !this.showPeanl;
      } else {
        clearTimeout(this.timer1);
        this.showLoading = true;
        // console.log(this.showPeanl, this.showLoading);
        this.timer1 = setTimeout(() => {
          this.showLoading = false;
          this.loadingState = true;
          this.showPeanl = true;
          this.canClick = true;
        }, 5000);
      }
    },
    /* zkb */
    handlerShowPeanl1(point) {
      this.$emit("changeBreak", point);
      if (this.showPeanl1) {
        this.showPeanl1 = !this.showPeanl1;
      } else {
        clearTimeout(this.timer1);
        this.showLoading = true;
        this.timer1 = setTimeout(() => {
          this.penalObject.forEach((object) => {
            if (object.name.includes(point)) {
              object.visible = !object.visible;
            } else {
              object.visible = false;
            }
          });
          this.showLoading = false;
          this.loadingState = true;
          this.showPeanl1 = true;
          this.canClick = true;
        }, 2000);
      }
    },
    handlerShowPeanl1Fun(point,i) {
      this.$emit("changeBreak", point);
      if (this.showPeanl1) {
        this.showPeanl1 = !this.showPeanl1;
      } else {
        clearTimeout(this.timer1);
        this.showLoading = true;
        this.timer1 = setTimeout(() => {
          this.penalObject.forEach((object) => {
            if (object.name.includes(point)) {
              object.visible = !object.visible;
            } else {
              object.visible = false;
            }
          });
          this.showLoading = false;
          this.loadingState = true;
          this.showPeanl1 = true;
          this.canClick = true;
        }, 2000);
      }
      //只能点开一个
      let list = [1,3,4,5].filter(item=>item!==i)

      list.forEach(item=>{
        this[`showPeanl${item}`] = false
      })
    },
    /* zkbdj */
    handlerShowPeanl2(point) {
      this.$emit("changeBreak", point);
      if (this.showPeanl2) {
        this.showPeanl2 = !this.showPeanl2;
      } else {
        clearTimeout(this.timer2);
        this.showLoading = true;
        this.timer2 = setTimeout(() => {
          this.penalObject.forEach((object) => {
            if (object.name.includes(point)) {
              object.visible = !object.visible;
            } else {
              object.visible = false;
            }
          });
          this.showLoading = false;
          this.loadingState = true;
          this.showPeanl2 = true;
          this.canClick = true;
        }, 5000);
      }
    },
    /* hrq */
    handlerShowPeanl3(point) {
      this.$emit("changeBreak", point);
      if (this.showPeanl3) {
        this.showPeanl3 = !this.showPeanl3;
      } else {
        clearTimeout(this.timer3);
        this.showLoading = true;
        this.timer3 = setTimeout(() => {
          this.penalObject.forEach((object) => {
            if (object.name.includes(point)) {
              object.visible = !object.visible;
            } else {
              object.visible = false;
            }
          });
          this.showLoading = false;
          this.loadingState = true;
          this.showPeanl3 = true;
          this.canClick = true;
        }, 2000);
      }
    },
    handlerShowPeanlFun(point,i) {
      this.$emit("changeBreak", point);
      
      if (this[`showPeanl${i}`]) {
        this[`showPeanl${i}`] = !this[`showPeanl${i}`];
      } else {
        clearTimeout(this[`timer${i}`]);
        this.showLoading = true;
        this[`timer${i}`] = setTimeout(() => {
          this.penalObject.forEach((object) => {
            if (object.name.includes(point)) {
              object.visible = !object.visible;
            } else {
              object.visible = false;
            }
          });
          this.showLoading = false;
          this.loadingState = true;
          this[`showPeanl${i}`] = true;
          this.canClick = true;
        }, 2000);
      }

    },
    changeStatus() {
      this.timer = setInterval(() => {
        if (this.faultStatus === "warning") {
          this.faultStatus = "error";
        } else {
          this.faultStatus = "warning";
        }
      }, 30000);
    },
    handlerJump2Shop() {
      this.$emit("onlineChange", true);
    },
  },
  beforeUnmount() {
    if (!this.is3D) {
      return;
    }
    scene.traverse((child) => {
      if (child.material) {
        child.material.dispose();
      }
      if (child.geometry) {
        child.geometry.dispose();
      }
      child = null;
    });
    renderer.forceContextLoss();
    renderer.dispose();
    scene.clear();
    scene = null;
    camera = null;
    controls = null;
    renderer.domElement = null;
    renderer = null;
  },
};
</script>

<style scoped lang="scss">
.model-3D {
  width: 100%;
  height: 100%;
  .scene {
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  .controls {
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 999;
  }
  #yiImg,
  #penal {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    .showButton {
      position: absolute;
      width: 50px;
      height: 50px;
      display: flex;
      border-radius: 50%;
      justify-content: center;
      align-items: center;
      z-index: 9;
      .innerCircle {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        position: absolute;
      }
      .outerCircle {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        position: absolute;
        animation: lockLight 1.2s ease-in-out infinite;
      }

      .warning {
        background: linear-gradient(90deg, #e2b32c -0.12%, #fedd64 100%);
        color: #ffffff;
      }

      .error {
        background: linear-gradient(90deg, #a4373b -0.12%, #b97f89 100%);
        color: #ffffff;
      }
      .success {
        background: linear-gradient(90deg, #66f876 -0.12%, #50c55d 100%);
        color: #ffffff;
      }
    }

    @keyframes lockLight {
      0% {
        opacity: 1;
        transform: scale(1);
      }
      20% {
        opacity: 0.8;
        transform: scale(1.5);
      }
      40% {
        opacity: 0.6;
        transform: scale(2);
      }
      60% {
        opacity: 0.4;
        transform: scale(2.5);
      }
      80% {
        opacity: 0.2;
        transform: scale(3);
      }
      100% {
        opacity: 0;
        transform: scale(3);
      }
    }
  }

  #state-lgb {
    position: absolute;
    padding: 5px;
    min-width: 200px;
    width: auto;
    border-radius: 30px;
    text-align: center;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff !important;
    .icon-fault {
      width: 30px;
      margin-right: 5px;
    }

    &.warning {
      background: radial-gradient(
        48% 68.53% at 52% 55%,
        #e1dfa5 0%,
        #f8c533 100%
      );
    }
    &.error {
      background: radial-gradient(
        48% 68.53% at 52% 55%,
        rgba(255, 168, 167, 0.8) 0%,
        #ca3938 100%
      );
    }
  }

  .mark-lgb {
    position: absolute;
    box-sizing: border-box;
    min-width: 380px;
    max-width: 550px;
    color: #ffffff;
    &.warning-bg {
      background: url("../../../assets/penal-warning.png") no-repeat;
      background-size: 100% 100%;
    }
    &.error-bg {
      background: url("../../../assets/penal-error.png") no-repeat;
      background-size: 100% 100%;
    }

    .mark-head {
      border-top-left-radius: 17px;
      box-sizing: border-box;
      font-size: 24px;
      font-weight: 600;
      padding: 10px 0 10px 10px;
      margin: 3px 3px 0 3px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        width: 30px;
        margin-right: 8px;
      }
      &.warning {
        background: radial-gradient(
          48% 68.53% at 52% 55%,
          #e1dfa5 0,
          #f8c533 100%
        );
        color: #ffffff;
      }
      &.error {
        background: radial-gradient(
          48% 68.53% at 52% 55%,
          rgba(255, 168, 167, 0.8) 0,
          #ca3938 100%
        );
        color: #ffffff;
      }

      .online-shop {
        display: flex;
        align-items: center;
        font-size: 14px;
        .icon-online {
          width: 18px;
          margin-left: 8px;
        }
        &:hover {
          cursor: pointer;
        }
      }
    }

    .mark-body {
      border-bottom-right-radius: 35px;
      margin: 0 3px 3px;
      color: #ffffff !important;
      &.warning {
        background: rgba(255, 231, 142, 0.5);
      }
      &.error {
        background: rgba(194, 142, 147, 0.5);
      }
    }

    .mark-main {
      padding: 5px 10px;
      // border-bottom: 1px dashed;
      color: #ffffff;

      &.warning {
        border-color: #f8c533;
      }
      &.error {
        border-color: #ca3938;
      }
      &:nth-of-type(1) {
        padding-top: 20px;
      }
      &:nth-last-of-type(1) {
        border: none;
      }
      .main-head {
        display: flex;
        align-items: center;
        .title-icon {
          width: 15px;
        }
        .mark-title {
          margin-left: 5px;
          font-size: 18px;
          line-height: 16px;
          font-weight: 600;
          color: #ffffff !important;
        }
      }
      .mark-cont {
        color: #ffffff !important;
        padding: 5px 0 0px 20px;
        font-size: 16px;
        .point-icon {
          width: 4px;
          margin-right:0.5rem;
        }
      }
    }
  }

  #state-hrq,
  #state-zkb,
  #state-zkbdj {
    position: absolute;
    // top: -0.5rem;
    padding: 5px;
    min-width: 175px;
    width: auto;
    border-radius: 30px;
    text-align: center;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    span{
      /* 文字不换行 */ 
      white-space:nowrap;
    }
    .icon-fault {
      width: 30px;
      margin-right: 5px;
    }

    &.warning {
      background: radial-gradient(
        48% 68.53% at 52% 55%,
        #e1dfa5 0%,
        #f8c533 100%
      );
    }
    &.error {
      background: radial-gradient(
        48% 68.53% at 52% 55%,
        rgba(255, 168, 167, 0.8) 0%,
        #ca3938 100%
      );
    }
  }
  .mark-zkbdj,
  .mark-zkb,
  .mark-hrq {
    position: absolute;
    box-sizing: border-box;
    min-width: 340px;
    max-width: 460px;

    &.warning-bg {
      background: url("../../../assets/penal-warning.png") no-repeat;
      background-size: 100% 100%;
    }
    &.error-bg {
      background: url("../../../assets/penal-error.png") no-repeat;
      background-size: 100% 100%;
    }

    .mark-head {
      border-top-left-radius: 17px;
      box-sizing: border-box;
      font-size: 24px;
      font-weight: 600;
      padding: 10px 0 10px 10px;
      margin: 3px 3px 0 3px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .head {
        flex: 1;
      }
      img {
        width: 30px;
        margin-right: 8px;
      }
      &.warning {
        background: radial-gradient(
          48% 68.53% at 52% 55%,
          #e1dfa5 0,
          #f8c533 100%
        );
        color: #ffffff;
      }
      &.error {
        background: radial-gradient(
          48% 68.53% at 52% 55%,
          rgba(255, 168, 167, 0.8) 0,
          #ca3938 100%
        );
        color: #ffffff;
      }
      .online-shop {
        margin-left: 30px;
        display: flex;
        align-items: center;
        font-size: 14px;
        .icon-online {
          width: 18px;
          margin-left: 8px;
        }
        &:hover {
          cursor: pointer;
        }
      }
    }

    .mark-body {
      border-bottom-right-radius: 28px;
      margin: 0 3px 3px;
      &.warning {
        background: rgba(255, 231, 142, 0.5);
      }
      &.error {
        background: rgba(194, 142, 147, 0.5);
      }
    }

    .mark-main {
      padding: 5px 10px;
      // border-bottom: 1px dashed;

      &.warning {
        border-color: #f8c533;
      }
      &.error {
        border-color: #ca3938;
      }
      &:nth-of-type(1) {
        padding-top: 20px;
      }
      &:nth-last-of-type(1) {
        border: none;
      }
      .main-head {
        display: flex;
        align-items: center;
        .title-icon {
          width: 15px;
        }
        .mark-title {
          margin-left: 5px;
          font-size: 18px;
          line-height: 16px;
          font-weight: 600;
          color: #ffffff !important;
        }
      }
      .mark-cont {
        color: #ffffff !important;
        padding: 5px 0 0px 20px;
        font-size: 16px;
        .point-icon {
          width: 4px;
          margin-right:0.5rem;
        }
      }
    }
  }

  .mark-zkb {
    top: 0rem;
    left: 1.5rem;
  }

  .mark-zkbdj {
    top: 0rem;
    left: 0rem;
  }

  .mark-hrq {
    top: 0rem;
    left: 1rem;
  }
  .mark-lgb-warning {
    top: -0.92rem;
    left: -0.2rem;
  }
  .mark-lgb-error,
  .mark-lgb-warning {
    top: 0;
    left: 0.95rem;
  }
}
$width: 130px;
$height: 130px;
$dotwidth: 20px;
$dotheight: 20px;
$radius: 8px;
$offset: 16px;

@keyframes changeopacity {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.2;
  }
}
.loading {
  width: 130px;
  height: 130px;
  z-index: 99999;
  position: absolute;
  top: 35%;
  right: 50%;

  .dot {
    width: $dotwidth;
    height: $dotheight;
    position: absolute;
    background: conic-gradient(
      from 65.38deg at 50% 50%,
      #04ffff 0deg,
      #04ffff 360deg
    );
    border-radius: 50% 50%;
    opacity: 1;
    animation: changeopacity 1.04s ease infinite;
  }
  .dot-static {
    width: $dotwidth;
    height: $dotheight;
    position: absolute;
    background: conic-gradient(
      from 65.38deg at 50% 50%,
      #04ffff 0deg,
      #04ffff 360deg
    );
    border-radius: 50% 50%;
  }
  .dot1 {
    left: 0;
    top: 50%;
    margin-top: -$radius;
    animation-delay: 0.13s;
  }
  .dot2 {
    left: $offset;
    top: $offset;
    animation-delay: 0.26s;
  }
  .dot3 {
    left: 50%;
    top: 0;
    margin-left: -$radius;
    animation-delay: 0.39s;
  }
  .dot4 {
    top: $offset;
    right: $offset;
    animation-delay: 0.52s;
  }
  .dot5 {
    right: 0;
    top: 50%;
    margin-top: -$radius;
    animation-delay: 0.65s;
  }
  .dot6 {
    right: $offset;
    bottom: $offset;
    animation-delay: 0.78s;
  }
  .dot7 {
    bottom: 0;
    left: 50%;
    margin-left: -$radius;
    animation-delay: 0.91s;
  }
  .dot8 {
    bottom: $offset;
    left: $offset;
    animation-delay: 1.04s;
  }

  .text {
    font-size: 16px;
    width: 50%;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.mark-head {
  border-top-left-radius: 17px;
  box-sizing: border-box;
  font-size: 24px;
  font-weight: 600;
  padding: 5px 0 5px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    width: 30px;
    margin-right: 8px;
  }
  &.warning {
    background: radial-gradient(48% 68.53% at 52% 55%, #e1dfa5 0, #f8c533 100%);
    color: #ffffff;
  }
  &.error {
    background: radial-gradient(
      48% 68.53% at 52% 55%,
      rgba(255, 168, 167, 0.8) 0,
      #5df36f 100%
    );
    color: #ffffff;
  }

  .online-shop {
    display: flex;
    align-items: center;
    font-size: 14px;
    .icon-online {
      width: 18px;
      margin-left: 8px;
    }
    &:hover {
      cursor: pointer;
    }
  }
}

.mark-body {
  border-bottom-right-radius: 35px;
  margin: 0 3px 3px;
  color: #ffffff !important;
  &.warning {
    background: rgba(255, 231, 142, 0.5);
  }
  &.error {
    background: #5df36f;
  }
}

.mark-main {
  padding: 5px 10px;
  // border-bottom: 1px dashed;
  color: #ffffff;

  &.warning {
    border-color: #f8c533;
  }
  &.error {
    border-color: #5df36f;
  }
  &:nth-of-type(1) {
    padding-top: 20px;
  }
  &:nth-last-of-type(1) {
    border: none;
  }
  .main-head {
    display: flex;
    align-items: center;
    .title-icon {
      width: 15px;
    }
    .mark-title {
      margin-left: 5px;
      font-size: 18px;
      line-height: 16px;
      font-weight: 600;
      color: #ffffff !important;
    }
  }
  .mark-cont {
    color: #ffffff !important;
    padding: 5px 0 0px 20px;
    font-size: 15px;
    .point-icon {
      width: 4px;
      margin-right:0.5rem;
    }
  }
}
.head-cont{
  white-space:nowrap;
}
</style>
